import { render, staticRenderFns } from "./PortFolio.vue?vue&type=template&id=e381e36e&scoped=true&"
import script from "./PortFolio.vue?vue&type=script&lang=js&"
export * from "./PortFolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e381e36e",
  null
  
)

export default component.exports